import BaseInteraction from './BaseInteraction';
import ContentItem from '../api/content/ContentItem';
import attachViblastInterceptor from './viblast/attachViblastInterceptor';
import getAttachableElement from './viblast/getAttachableElement';
import logger from '../log';
import { DeliveryMode, SourceType } from '../common/constants';
import { TechApi } from '../bootloader/tech';
import {
  ViblastOptions,
  ViblastVideoJsPlayer
} from '@kollective-frontend/ksdk-api';
import { ErrorMessages } from '@kollective-frontend/ksdk-api';
import { dispatchError } from '../events/dispatch';

const log = logger.getLogger(__filename);

export default class ViblastInteraction extends BaseInteraction<ViblastVideoJsPlayer> {
  constructor(
    player: ViblastVideoJsPlayer,
    options: ViblastOptions,
    tech: TechApi
  ) {
    super(player, tech, [DeliveryMode.WEBRTC, DeliveryMode.ECDN11]);
    this.element = getAttachableElement(player, options);
    if (typeof this.element === 'undefined') {
      log.error(ErrorMessages.VIBLAST_NO_EVENT_LISTENERS);
      dispatchError(ErrorMessages.VIBLAST_NO_EVENT_LISTENERS);
    }
    // Bitrate Tracking:
    // Currently there is no way to track the bitrates. When using VideoJS with
    // Viblast, the tech object doesn't have the hls or vhs object, so we aren't
    // able to get the bitrate as we do in straight VideoJs, additionally straight
    // Viblast just modifies the video element, and the API doesn't have any way to
    // track the current bitrate.
    try {
      attachViblastInterceptor(this);
    } catch (e) {
      log.error(ErrorMessages.TECH_API, e);
      dispatchError(ErrorMessages.TECH_API);
    }
  }

  loader(items: ContentItem[]): ContentItem[] {
    // We don't set sources for Viblast
    return items;
  }

  setSource(): Promise<void> {
    // We don't reset source for Viblast (that would need to stop and restart
    // the viblast player)
    return Promise.resolve();
  }

  clearSource(): void {
    // We don't modify the source for Viblast
  }

  mediaElement(): HTMLMediaElement | undefined {
    return this.element;
  }

  getAllowedSourceTypes(): SourceType[] {
    return [SourceType.HLS, SourceType.DASH];
  }
}
